<template>
  <div id="tab-data-mentah">
    <div v-if="is_quote" class="row mt-4">
      <div class="col-3 px-gap">
        <div class="bg-white rounded p-3 shade" id="top-speaker">
          <div
            class="d-flex align-items-center mb-2"
            style="cursor: pointer; margin-top: 7px"
            @click="is_collapse = !is_collapse"
          >
            <div class="h5 ml-auto">Speakers</div>
            <i
              class="fa mb-2 ml-2 mr-auto"
              :class="is_collapse ? 'bi bi-chevron-down' : 'bi bi-chevron-up'"
            ></i>
          </div>
          <loader-component v-if="is_loading" />
          <div v-else>
            <div
              v-if="is_collapse"
              class="scroller"
              style="max-height: 46.3rem"
            >
              <div v-if="top_speaker">
                <div
                  class="card card-default border py-2 speaker"
                  style="border-radius: 10px"
                  :class="speaker_selected == data._id ? 'bg-complete' : ''"
                  v-for="data in top_speaker"
                  :key="data._id"
                  @click="getSpeakerMention(data._id)"
                >
                  <center>
                    <div class="user-pic mb-2">
                      <img
                        alt="Profile Image"
                        src="/assets/img/profiles/default.jpg"
                        class="img-circle"
                      />
                    </div>
                    <p class="h5">{{ data._id }}</p>
                    <span>
                      <span class="h5 mr-1">{{
                        thousandSeparator(data.count)
                      }}</span>
                      <span class="h6">Statements</span>
                    </span>
                  </center>
                </div>
              </div>
              <div v-else class="col-md-12 col-sm-12 col-lg-12">
                <div
                  class="alert alert-danger mt-3"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                  Silahkan lakukan pencarian dengan parameter lain
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-9 px-gap">
        <div class="bg-white rounded p-3 shade">
          <div class="d-flex align-items-center my-2">
            <div class="h5">Daftar Statement</div>
            <div
              class="form-group input-group input-group-right transparent m-b-0 m-t-0 ml-auto"
              style="width: 8rem"
            >
              <select
                v-model="per_page"
                id="filter-halaman"
                class="form-control form-custom"
                @change="filterSource()"
              >
                <option value="10">10 Quote per Halaman</option>
                <option value="25">25 Quote per Halaman</option>
                <option value="50">50 Quote per Halaman</option>
                <option value="100">100 Quote per Halaman</option>
              </select>
              <div class="input-group-append">
                <span class="input-group-text transparent">
                  <i class="bi bi-file-earmark-break"></i>
                </span>
              </div>
            </div>
            <div
              class="form-group input-group input-group-right transparent m-b-0 m-t-0 ml-2"
              style="width: 8rem"
            >
              <select
                v-model="sort_time"
                id="filter-terbaru"
                class="form-control form-custom"
                @change="filterSource()"
              >
                <option value="esmr">Terpopuler</option>
                <option value="date">Terbaru</option>
                <option value="engagement">Engagement</option>
              </select>
              <div class="input-group-append">
                <span class="input-group-text transparent">
                  <i class="bi bi-sort-down-alt" style="font-size: 18px"></i>
                </span>
              </div>
            </div>
            <div
              class="form-group input-group input-group-right transparent m-b-0 m-t-0 ml-2"
              style="width: max-content"
            >
              <select
                v-model="source"
                id="filter-source"
                class="form-control form-custom"
                @change="filterSource()"
              >
                <option value="all">Semua Media</option>
                <option value="news">Online News</option>
                <option value="media_cetak">Media Cetak</option>
                <option value="media_tv">Media TV</option>
              </select>
              <div class="input-group-append">
                <span class="input-group-text transparent">
                  <i class="bi bi-chevron-down" style="font-size: 16px"></i>
                </span>
              </div>
            </div>
            <div
              class="input-group input-group-right ml-2"
              id="search"
              style="width: 10rem"
            >
              <input
                v-model="quote"
                type="text"
                class="form-control form-custom"
                placeholder="Cari.."
                @change="searchItem"
              />
              <div
                class="input-group-append"
                @click="searchItem"
                style="cursor: pointer"
              >
                <span
                  class="input-group-text hoverable clickable bg-transparent"
                >
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
            <button
              v-if="quote"
              class="btn btn-danger ml-2"
              style="height: 2.15rem"
              @click="deleteSearch"
            >
              <i class="bi bi-trash"></i>
            </button>
          </div>
          <loader-component v-if="is_loading_mention" />
          <div v-else class="scrolling-wrapper">
            <statement-list-component
              v-if="quotes"
              :quotes="quotes"
              max_height="43.2rem"
              @quoteFilterChange="getData"
              class="mt-3"
            />
            <div v-else class="col-md-12 col-sm-12 col-lg-12">
              <div
                class="alert alert-danger mt-3"
                id="errorApiEl"
                role="alert"
                align="center"
              >
                <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                Silahkan lakukan pencarian dengan parameter lain
              </div>
            </div>
          </div>
          <div align="right">
            <pagination-component
              v-if="page_info"
              :data="page_info"
              :goto="true"
              :key="pagination_key"
              class="pull-right"
              @pageChange="getData"
            />
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row m-t-10">
      <div class="col-12">
        <div class="bg-white p-l-20 p-t-10 p-r-20 p-b-5">
          <p>Silahkan hubungi administrator untuk membuka fitur ini.</p>
        </div>
      </div>
    </div>
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>
  
<script>
import $ from "jquery";
import pagination from "@/views/components/pagination.vue";
import loader from "@/views/components/loader.vue";
import statement_list from "@/views/components/quotes-extraction/statement_list.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "tab_data_mentah",
  components: {
    "pagination-component": pagination,
    "loader-component": loader,
    "statement-list-component": statement_list,
  },
  data() {
    return {
      source: "all",
      per_page: 10,
      sort_time: "date",
      id_project: this.$store.getters.user.id_project,
      is_quote: this.$store.getters.user.project.project_detail
        .quotes_extraction
        ? true
        : false,
      quotes: null,
      quote: "",
      page_info: null,
      pagination_key: 0,
      is_loading: true,
      is_loading_mention: true,
      is_collapse: true,
      top_speaker: null,
      tour_steps: [],
      speaker_selected: "",
    };
  },
  methods: {
    filterChange: function () {
      this.getData();
      this.getTopSpeaker();
    },
    getData: function (edit) {
      this.is_loading_mention = true;
      let api = process.env.VUE_APP_API_URL + "quotes_posts/" + this.id_project;
      let page = "page" in this.$route.query ? this.$route.query.page : 1;

      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
        items: this.per_page,
        sort: this.sort_time,
        page: page,
        ...(this.quote ? { quote: this.quote } : {}),
        ...(this.speaker_selected ? { speaker: this.speaker_selected } : {}),
        ...(this.source != "all" ? { sources: btoa(this.source) } : {}),
      };
      if ("topic_selected" in this.$route.query) {
        query.topic_selected = this.$route.query.topic_selected;
      }
      if ("cakupan" in this.$route.query) {
        query.cakupan = this.$route.query.cakupan;
      }
      if ("group" in this.$route.query) {
        query.group = this.$route.query.group;
      }
      this.$http
        .get(api, { params: query })
        .then((response) => {
          this.quotes = response.data.quotes;
          this.page_info = response.data.page_info;
          if (!edit) {
            $("html,body").animate({ scrollTop: 0 }, 200);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.pagination_key++;
          this.is_loading_mention = false;
        });
    },
    getTopSpeaker: function () {
      this.is_loading = true;
      let api = process.env.VUE_APP_API_URL + "top-speaker/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
        limit: 20,
      };
      if ("topic_selected" in this.$route.query) {
        query.topic_selected = this.$route.query.topic_selected;
      }
      if ("group" in this.$route.query) {
        query.group = this.$route.query.group;
      }
      if ("cakupan" in this.$route.query) {
        query.cakupan = this.$route.query.cakupan;
      }
      this.$http
        .get(api, { params: query })
        .then((response) => {
          this.top_speaker = response.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    imageUrlAlt: function () {
      event.target.src = "/assets/img/profiles/default.png";
    },
    thousandSeparator: function (val) {
      return gp.thousandSeparator(val);
    },
    getSpeakerMention: function (id) {
      if (this.speaker_selected == id) {
        this.speaker_selected = "";
        this.getData();
      } else {
        this.speaker_selected = id;
        this.getData();
      }
    },
    filterSource: function () {
      this.getData();
    },
    deleteParam: function (key) {
      let queries = this.$route.query;
      delete queries[key];
      let self = this;
      let current_path = this.$route.path;
      this.$router
        .replace(current_path)
        .then(self.$router.replace({ query: queries }));
    },
    deleteSearch: function () {
      this.quote = "";
      this.getData();
    },
    searchItem: function () {
      this.getData();
    },
  },
  watch: {
    $route() {
      this.getData();
      this.getTopSpeaker();
    },
  },
  created: function () {
    this.getData();
    this.getTopSpeaker();
  },
  mounted() {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#top-speaker",
      header: {
        title: "Top Speaker",
      },
      content: `Menampilkan 20 Speaker teratas dengan jumlah statement terbanyak dalam range waktu sesuai dengan filter tanggal.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#filter-source",
      header: {
        title: "Filter Source",
      },
      content: `Digunakan untuk memfilter data yang akan ditampilkan berdasarkan sumber.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#search",
      header: {
        title: "Pencarian",
      },
      content: `Digunakan untuk memfilter data yang akan ditampilkan berdasarkan kata kunci yang dimasukkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#filter-terbaru",
      header: {
        title: "Filter Terbaru",
      },
      content: `Anda dapat mengurutkan data berdasarkan engagement, popularitas dan posting terbaru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#filter-halaman",
      header: {
        title: "Filter Halaman",
      },
      content: `Anda dapat menampilkan data sebanyak halaman yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#statement",
      header: {
        title: "Statement",
      },
      content: `Menampilkan data statement pada postingan sesuai dengan range waktu sesuai dengan filter tanggal.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#lihat-berita",
      header: {
        title: "Lihat Berita",
      },
      content: `Klik untuk melihat berita dari statement yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#edit-statement",
      header: {
        title: "Edit Statement",
      },
      content: `Klik untuk mengedit statement yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#hapus-statement",
      header: {
        title: "Hapus Statement",
      },
      content: `Klik untuk menghapus statement yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>
<style scoped>
.form-sorting-post {
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(33, 33, 33, 0.14);
  border-top-color: rgba(33, 33, 33, 0.21);
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif, sans-serif;
  -webkit-appearance: button;
  color: #212121;
  outline: 0;
  padding: 6px 8px;
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  min-height: 32px;
  -webkit-transition: all 0.12s ease;
  transition: all 0.12s ease;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-transition: background 0.2s linear 0s;
  transition: background 0.2s linear 0s;
}
.speaker:hover {
  opacity: 0.5;
  cursor: pointer;
}
.user-pic {
  width: 40px !important;
  height: 40px !important;
  position: relative;
  background-color: #17a2b8 !important;
  border-radius: 50%;
}
.img-circle {
  height: inherit !important;
  width: inherit !important;
  border-radius: 50%;
  border: 2px #ccc solid;
}
</style>